// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { migrateTokens } from "./utils/auth";

// Migrate legacy tokens before rendering the app
// This handles existing sessions with old token keys
migrateTokens();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
